export const VSF_MHJ_MY_STORE_NAME = 'vsf-mhj-my-store-name'

export const VSF_MHJ_MY_STORE_ID = 'vsf-mhj-my-store-id'

export const VSF_MHJ_MY_STORE_SEARCH_TERM = 'vsf-mhj-my-store-search-term'

// Session cookie (no expiry) so the header Set My Store popover shows once per browser session.
export const VSF_MHJ_SET_STORE_TIP_SEEN = 'vsf-mhj-set-store-tip-seen'

// Persisted Braze external id (CID) for the authenticated customer, namespaced by customerId.
// Lets the Braze identity be re-affirmed on every load without a network round-trip. See useBrazeIdentity.
export const VSF_MHJ_BRAZE_CID = 'vsf-mhj-braze-cid'
